export default {
    noEmojiOptionsAvailable: 'No emoji options available',
    previousQuestion: 'Previous Question',
    nextQuestion: 'Next Question',
    submit: 'Submit evaluation',
    skipThisQuestion: 'Skip this question',
    addCommentOptional: 'Add a comment (optional)',
    addAnComment: 'Add a comment',
    typeYourComment: 'Type your comment',
    commentDetailsPlaceholder: 'Provide as much details as possible',
    ariaPreviousQuestion: 'Go to previous question',
    ariaNextQuestion: 'Go to next question',
    ariaSubmit: 'Submit evaluation',
    ariaSkipQuestion: 'Skip this question',
    submitConfirm: {
        title: 'Confirm your submission',
        message: 'This is the final question. Skipping it will submit your evaluation immediately.',
        confirm: 'Submit evaluation',
    },
    confidentiality: {
        noResults:
            'Your responses are visible to the {{managerLabel}} of the person being evaluated. The employee being evaluated does not see any results: a summary will be presented to them.',
        scoresOnly:
            'Your responses are visible to the {{managerLabel}} of the person being evaluated. The employee being evaluated only sees the aggregated scores from all reviewers. They do not see any written comments, and a summary of the results will be presented to them.',
        scoresAndComments:
            'Your responses, scores and comments included, are visible to the {{managerLabel}} of the person being evaluated. The employee being evaluated does not see your responses.',
        anonymous: 'Anonymous answer: your name is never shown.',
        moreInfo: 'See more info',
        detailsTitle: 'What will be visible',
        named: 'Named answer: your name is shown with this answer. {{visibility}}',
        namedLaunchedByReviewee:
            'Your responses are visible to the {{managerLabel}} of the person being evaluated. {{revieweeSees}}',
    },
    feedbackPrivacy: {
        respondent: 'Respondent',
        deletedAccount: 'Deleted account',
        acknowledge: 'Start the feedback',
        anonymous: {
            title: 'Your feedback is <lock>anonymous</lock>',
            titleWithName: 'Your feedback on {{name}} is <lock>anonymous</lock>',
            hidden: '<bold>Your name, your photo and the date of your answer</bold> will never be shown to the {{managerLabel}} of the person being evaluated, nor to HR.',
            threshold:
                'Answers only become visible to the {{managerLabel}} of the person being evaluated once at least <bold>{{minimum}} respondents</bold> have answered.',
            revieweeSeesNoAnswer:
                'The person being evaluated will <bold>not see any answers</bold>.',
            commentsOrder:
                '<bold>Dates will not be shown</bold> and written comments will appear in <bold>random order</bold>.',
            revieweeLaunched:
                'The person being evaluated launched this 360 feedback themselves: they will also see its results, without any name.',
            mixedWithOthers:
                "Your answers are mixed with those of the other respondents, without any name, as everyone's are.",
        },
        named: {
            revieweeLaunched:
                'The person being evaluated launched this 360 feedback themselves: they will also see your responses, with your name.',
            title: 'Feedback',
            titleWithName: 'Feedback for {{name}}',
            lead: 'This feedback is not anonymous.',
            seen: 'The {{managerLabel}} of the person being evaluated will see your profile and your comments.',
            yourName: 'Your name',
            reviewee:
                'The person being evaluated will not see any answers. Their {{managerLabel}} is the one who will analyze the findings and present them in aggregate.',
        },
    },
    progression: 'Progression',
    surveyAnswer: {
        featureItem: {
            title: 'Share your feedback',
            description:
                'We would like to gather your comments about the collaboration with your colleagues. Your answers will be visible to the {{managerLabel}} of the person being evaluated. {{revieweeSees}}',
            anonymousDescription:
                'We would like to gather your comments about the collaboration with your colleagues. Your answers will be visible to the {{managerLabel}} of the person being evaluated, without your name. {{revieweeSees}}',
            revieweeSeesNoAnswer: 'The person being evaluated will not see any answers.',
        },
        reviewedCollegue: 'Reviewed employee',
        selfEvaluationTitle: 'Your Self-Assessment',
        selfEvaluationDescription:
            'This is the time to step back and reflect on your journey. Your reflections will fuel a rich discussion with your {{managerLabel}} and help you chart the path ahead. Be authentic, your voice matters.',
        selfEvaluationPill: 'Self-assessment',
    },
    validation: {
        atLeastOneOptionRequired: 'Please select at least one option',
        minThreeCharacters: 'Please enter at least 3 characters',
        ratingRequired: 'Please select a rating',
        allOptionsMustBeRanked: 'Please rank all options',
        otherOptionRequired: 'Please enter your "Other" option answer',
        maxChoicesReached:
            'You have already reached the maximum number of choices in this question, please unselect one to add a new one.',
    },
    otherOption: {
        placeholder: 'Please input your option here',
        charLimitTooltip: 'Please write an option of less than 50 characters.',
    },
    pastedTextTruncated:
        'The pasted text was over {{maxLength}} characters: only the first {{maxLength}} were kept.',
};
